<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Radio</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content">
  <ng-container *ngIf="isBrowser;else noJsContent">
    <h2 id="radioGroupLabeledby1">Radio Use Case 1 : Angular Form</h2>
    <form [formGroup]="form" (ngSubmit)="submitted = true" id="form1">
      <maced-radio-group radioGroupLabelledby="radioGroupLabelledby1" label="Label" radioGroupId="radioGroupId1" radioGroupLabel="radio group labelling" [required]="true" >
        <div class="c-input-outer__multiple-item">
          <maced-radio radioId="radioId1" value="TestValue1" label="label1" [name]="'testRadio'" [required]="true" formControlName="radio"
            [hasError]="(form.controls.radio.touched || submitted) && !!form.controls.radio.errors"
            [checked]="form.value.radio === 'TestValue1'" formId="form1" [hasRadioLabel]="false" [ariaLabel]="'Testing Label'">
          </maced-radio>
        </div>
        <div class="c-input-outer__multiple-item">
          <maced-radio radioId="radioId2" value="TestValue2" label="label2" [name]="'testRadio'" [required]="true" formControlName="radio"
            [hasError]="(form.controls.radio.touched || submitted) && !!form.controls.radio.errors"
            [checked]="form.value.radio === 'TestValue2'" formId="form1" [hasRadioLabel]="true">
          </maced-radio>
        </div>
        <div class="c-input-outer__helper-text">
          This is helper text
        </div>
        <div class="c-input-outer__multiple-error" role="alert"
          *ngIf="(form.controls.radio.touched || submitted) && form.controls.radio.errors?.required">
          This field is required
        </div>
      </maced-radio-group>
      <div class="u-mt-16">
        <maced-button buttonId="buttonId1" label="Submit" buttonType="submit"></maced-button>
      </div>
    </form>
    <p>
      Result:- {{ form.value.radio }}
    </p>

    <h2 id="radioGroupLabeledby2">Radio Use Case 2 : Disabled & Vertical State</h2>
    <form [formGroup]="form" (ngSubmit)="submitted = true">
      <maced-radio-group radioGroupId="radioGroupId2" radioGroupLabelledby="radioGroupLabelledby2" label="Label" label="Label" [required]="true" [disabled]="true"
        [isVertical]="true">
        <div class="c-input-outer__multiple-item">
          <maced-radio radioId="radioId3" value="TestValue3" label="label1" [required]="true" formControlName="radio"
            [hasError]="(form.controls.radio.touched) && !!form.controls.radio.errors"
            [checked]="true" [disabled]="true" [hasRadioLabel]="true">
          </maced-radio>
        </div>
        <div class="c-input-outer__multiple-item c-input-outer__multiple-item--selcted-disabled">
          <maced-radio radioId="radioId4" value="TestValue4" label="label2" [required]="true" formControlName="radio"
            [hasError]="(form.controls.radio.touched) && !!form.controls.radio.errors"
            [checked]="form.value.radio === 'TestValue4'" [disabled]="true" [hasRadioLabel]="true">
          </maced-radio>
        </div>
        <div class="c-input-outer__helper-text">
          This is helper text
        </div>
      </maced-radio-group>
    </form>

    <h2>Radio Use Case 3 : Error</h2>
    <maced-radio radioId="radioNgModelError" name="radioNgModelError" value="TestValue" label="label"
      [(ngModel)]="radioNgModelError" [hasError]="true" [hasRadioLabel]="true">
    </maced-radio>
    <div class="c-input-group__error"> Error message will go here </div>
    <p>
      Result:- {{ radioNgModelError }}
    </p>
  </ng-container>

  <ng-template #noJsContent>
    <h2>With Form</h2>
    <form action="/radio" method="get" id="form2">
      <maced-radio radioId="radioNgModel" name="radioNgModel" value="TestValue" label="label"
        [checked]="radioNgModel === 'TestValue'" formId="form2" [hasRadioLabel]="true">
      </maced-radio>
      <maced-button buttonId="buttonId2" label="Submit" buttonType="submit"></maced-button>
    </form>
    <p>
      Result:- {{ radioNgModel }}
    </p>
 <h2>Without Form</h2>
    <form action="/radio" method="get">
      <maced-radio radioId="radioNgModel1" name="radioNgModel1" value="TestValue1" label="label"
        [checked]="radioNgModel1 === 'TestValue1'" [hasRadioLabel]="true">
      </maced-radio>
      <maced-button buttonId="buttonId3" label="Submit" buttonType="submit"></maced-button>
    </form>
    <p>
      Result:- {{ radioNgModel1 }}
    </p>
  </ng-template>
</div>